var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAkarIconsYoutubeFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:youtube-fill",
    clipPath: "url(#clip0_163_985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5838 5.4224C19.4706 5.01843 19.25 4.65269 18.9455 4.36407C18.6324 4.06657 18.2487 3.85376 17.8305 3.74573C16.2655 3.33323 9.99551 3.33323 9.99551 3.33323C7.38162 3.30349 4.76837 3.4343 2.17051 3.7249C1.75234 3.84091 1.36932 4.05847 1.05551 4.35823C0.747181 4.6549 0.523848 5.02073 0.407181 5.42157C0.126925 6.93135 -0.00924233 8.46435 0.000514319 9.9999C-0.00948568 11.5341 0.126348 13.0666 0.407181 14.5782C0.521348 14.9774 0.743848 15.3416 1.05301 15.6357C1.36218 15.9299 1.74718 16.1424 2.17051 16.2549C3.75635 16.6666 9.99551 16.6666 9.99551 16.6666C12.6127 16.6963 15.2293 16.5655 17.8305 16.2749C18.2487 16.1669 18.6324 15.9541 18.9455 15.6566C19.2499 15.368 19.4702 15.0022 19.583 14.5982C19.8706 13.089 20.0104 11.5554 20.0005 10.0191C20.0221 8.47624 19.8825 6.93537 19.5838 5.42157V5.4224ZM8.00218 12.8532V7.1474L13.2188 10.0007L8.00218 12.8532Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsYoutubeFill);
export default __webpack_public_path__ + "static/media/akar-icons_youtube-fill.a14829c9337b8a43c8428bb80cb942a1.svg";
export { ForwardRef as ReactComponent };